import { render } from "./ArchaicOverview.vue?vue&type=template&id=24d3c4fe"
import script from "./ArchaicOverview.vue?vue&type=script&lang=js"
export * from "./ArchaicOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__